(function() {
  var STORAGE_KEY = 'tambur-favorites';

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }

  function write(handles) {
    var unique = [];
    handles.forEach(function(handle) {
      if (handle && unique.indexOf(handle) === -1) unique.push(handle);
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    updateBadges(unique.length);
    syncButtons();
    document.dispatchEvent(new CustomEvent('tambur:favorites-updated', {
      detail: { handles: unique.slice() }
    }));
    return unique;
  }

  function isFavorite(handle) {
    return read().indexOf(handle) !== -1;
  }

  /* Lampkombineraren sparar fot och skärm tillsammans när kombinationen
     saknar färdig vara. Därför kan ett hjärta bära flera handtag. */
  function parseHandles(value) {
    return String(value || '')
      .split(',')
      .map(function(handle) { return handle.trim(); })
      .filter(Boolean);
  }

  function allFavorites(handles) {
    if (!handles.length) return false;
    var list = read();
    return handles.every(function(handle) { return list.indexOf(handle) !== -1; });
  }

  function toggleMany(handles) {
    if (!handles.length) return read();
    var list = read();
    if (allFavorites(handles)) {
      list = list.filter(function(handle) { return handles.indexOf(handle) === -1; });
    } else {
      handles.forEach(function(handle) {
        if (list.indexOf(handle) === -1) list.push(handle);
      });
    }
    return write(list);
  }

  function updateBadges(count) {
    document.querySelectorAll('[data-favorites-count]').forEach(function(el) {
      el.textContent = count;
      if (count > 0) {
        el.hidden = false;
        el.removeAttribute('hidden');
      } else {
        el.hidden = true;
        el.setAttribute('hidden', '');
      }
    });
  }

  function syncButtons() {
    document.querySelectorAll('[data-favorite-toggle]').forEach(function(btn) {
      var handles = parseHandles(btn.getAttribute('data-product-handle'));
      if (!handles.length) return;
      var active = allFavorites(handles);
      btn.classList.toggle('is-favorite', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      var addLabel = btn.getAttribute('data-label-add') || 'Spara som favorit';
      var removeLabel = btn.getAttribute('data-label-remove') || 'Ta bort från favoriter';
      btn.setAttribute('aria-label', active ? removeLabel : addLabel);
    });
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatPrice(cents) {
    if (window.TamburFormatMoney) return window.TamburFormatMoney(cents);
    return (cents / 100) + ' ' + (window.TamburCurrency && window.TamburCurrency.iso || 'SEK');
  }

  function getFavoriteIconHtml() {
    var source = document.querySelector('[data-favorite-icon-source]');
    return source ? source.innerHTML.trim() : '';
  }

  function buildFavoriteButton(product) {
    var title = escapeHtml(product.title);
    var handle = escapeHtml(product.handle);
    return (
      '<button type="button" class="tambur-favorite-btn tambur-favorite-btn--card is-favorite" data-favorite-toggle data-product-handle="' + handle + '" data-label-add="Spara ' + title + ' som favorit" data-label-remove="Ta bort ' + title + ' från favoriter" aria-label="Ta bort ' + title + ' från favoriter" aria-pressed="true">' +
        '<span class="tambur-favorite-btn__icon" aria-hidden="true">' + getFavoriteIconHtml() + '</span>' +
      '</button>'
    );
  }

  function buildMediaHtml(product) {
    var images = product.images && product.images.length ? product.images.slice(0, 5) : [];
    if (!images.length && product.featured_image) images = [product.featured_image];

    if (!images.length) return '';

    var multiClass = images.length > 1 ? ' tambur-product-card__link--multi' : '';
    var slidesHtml = images.map(function(src, index) {
      return (
        '<div class="tambur-product-card__slide" data-slide-index="' + index + '">' +
          '<img src="' + escapeHtml(src) + '" alt="" class="tambur-product-card__image" loading="' + (index === 0 ? 'eager' : 'lazy') + '" width="600" height="818">' +
        '</div>'
      );
    }).join('');

    var barHtml = images.length > 1
      ? '<div class="tambur-product-card__bar" data-card-bar style="--n: ' + images.length + '">' +
          '<span class="tambur-product-card__progress" data-progress></span>' +
        '</div>'
      : '';

    return (
      '<div class="tambur-product-card__media-wrap">' +
        '<a href="' + escapeHtml(productUrl(product)) + '" class="tambur-product-card__link tambur-product-card__link--media' + multiClass + '" aria-label="' + escapeHtml(product.title) + '">' +
          '<div class="tambur-product-card__media" data-card-media>' +
            '<div class="tambur-product-card__slider" data-card-slider>' + slidesHtml + '</div>' +
            barHtml +
          '</div>' +
        '</a>' +
        buildFavoriteButton(product) +
      '</div>'
    );
  }

  function initCardSliders(root) {
    if (window.matchMedia('(min-width: 769px)').matches) return;
    if (!root || !('IntersectionObserver' in window)) return;

    root.querySelectorAll('[data-card-slider]').forEach(function(slider) {
      if (slider.dataset.sliderReady) return;
      slider.dataset.sliderReady = '1';

      var media = slider.closest('[data-card-media]');
      if (!media) return;
      var progress = media.querySelector('[data-progress]');
      if (!progress) return;

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.intersectionRatio > 0.6) {
            var idx = parseInt(entry.target.getAttribute('data-slide-index'), 10) || 0;
            progress.style.transform = 'translateX(' + (idx * 100) + '%)';
          }
        });
      }, { root: slider, threshold: [0.6] });

      slider.querySelectorAll('[data-slide-index]').forEach(function(slide) {
        observer.observe(slide);
      });
    });
  }

  /* Lampor och deras delar leder till kombineraren i stället för produktsidan,
     samma väg som kollektion och sök tar via lamp-kombinerarlank. De färdiga
     kombinationerna hålls med flit utanför kategorierna, så produktsidan är
     inte den sida butiken vill visa — och i kombineraren står lampan färdig. */
  function combinerUrl(handle) {
    var page = document.querySelector('[data-favorites-page]');
    if (!page) return '';
    var h = String(handle || '');
    var base = '';
    var param = '';

    if (h.indexOf('takpendel-') === 0) {
      base = page.getAttribute('data-pendant-page-url') || '';
      param = 'pendel';
    } else {
      base = page.getAttribute('data-lamp-page-url') || '';
      if (h.indexOf('bordslampa-tondo-') === 0) param = 'lampa';
      else if (h.indexOf('lampfot-tondo-') === 0) param = 'fot';
      else if (h.indexOf('lampskarm-') === 0) param = 'skarm';
    }

    if (!base || !param) return '';
    return base + '?' + param + '=' + encodeURIComponent(h);
  }

  function productUrl(product) {
    if (!product) return '';
    return combinerUrl(product.handle) || product.url || ('/products/' + product.handle);
  }

  /* Kategorisidorna visar en lampa per serie och gömmer resten med
     dölj-i-grid, annars skulle 141 nästan lika lampor rada upp sig. Här gäller
     det motsatta: kunden har valt varje kombination själv, och en favorit som
     tas bort ur listan ser ut som att sparandet inte fungerade. Kvar blir
     kraven som gör kortet ritbart. */
  function shouldShowInGrid(product) {
    if (!product) return false;
    var images = product.images && product.images.length ? product.images : [];
    if (!images.length && !product.featured_image) return false;
    var tags = product.tags || [];
    return !tags.some(function(tag) {
      var lc = String(tag).toLowerCase();
      return lc === 'set-komponent' || lc === 'set-artikel';
    });
  }

  function buildCard(product) {
    var priceHtml = '';
    if (product.compare_at_price && product.compare_at_price > product.price) {
      priceHtml =
        '<span class="tambur-product-card__price-sale">' + formatPrice(product.price) + '</span>' +
        '<span class="tambur-product-card__price-original">' + formatPrice(product.compare_at_price) + '</span>';
    } else {
      priceHtml = formatPrice(product.price);
    }

    var li = document.createElement('li');
    li.className = 'tambur-product-card';
    li.setAttribute('data-favorite-card', product.handle);

    li.innerHTML =
      buildMediaHtml(product) +
      '<div class="tambur-product-card__info">' +
        '<a href="' + escapeHtml(productUrl(product)) + '" class="tambur-product-card__title">' + escapeHtml(product.title) + '</a>' +
        '<div class="tambur-product-card__price-row">' +
          '<div class="tambur-product-card__price">' + priceHtml + '</div>' +
          '<span class="tambur-product-card__stock tambur-product-card__stock--in-stock">I webblager</span>' +
        '</div>' +
      '</div>';
    return li;
  }

  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function(res) {
      if (!res.ok) throw new Error('missing');
      return res.json();
    });
  }

  function formatFavoritesCount(countEl, n) {
    if (!countEl) return;
    var one = countEl.getAttribute('data-count-one') || '__COUNT__ produkt';
    var other = countEl.getAttribute('data-count-other') || '__COUNT__ produkter';
    var tpl = n === 1 ? one : other;
    countEl.textContent = tpl.replace(/__COUNT__/g, String(n));
  }

  var LIST_PARAM = 'lista';
  var pageProducts = [];
  var copyResetTimer = null;

  function parseSharedHandles() {
    try {
      var raw = new URLSearchParams(window.location.search).get(LIST_PARAM);
      if (!raw) return [];
      return raw.split(',').map(function(h) {
        return String(h).trim().toLowerCase();
      }).filter(function(h) {
        return /^[a-z0-9][a-z0-9-]*$/.test(h);
      });
    } catch (e) {
      return [];
    }
  }

  function applySharedList() {
    var shared = parseSharedHandles();
    if (!shared.length) return;
    var current = read();
    var merged = current.slice();
    shared.forEach(function(handle) {
      if (merged.indexOf(handle) === -1) merged.push(handle);
    });
    if (merged.length !== current.length) write(merged);
  }

  function shareUrl(handles) {
    var url = new URL(window.location.href);
    url.hash = '';
    if (handles.length) url.searchParams.set(LIST_PARAM, handles.join(','));
    else url.searchParams.delete(LIST_PARAM);
    return url.toString();
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function(resolve, reject) {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(ta);
      }
    });
  }

  function setShareVisible(page, n) {
    var share = page.querySelector('[data-favorites-share]');
    var form = page.querySelector('[data-favorites-mail]');
    if (share) share.hidden = n === 0;
    if (form && n === 0) form.hidden = true;
  }

  function fillPrintMeta(page, n) {
    var share = page.querySelector('[data-favorites-share]');
    var meta = page.querySelector('[data-favorites-print-meta]');
    if (!share || !meta) return;
    var lang = (document.documentElement.lang || 'sv').split('-')[0];
    var date = new Date().toLocaleDateString(lang === 'en' ? 'en-GB' : 'sv-SE', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
    var tpl = n === 1
      ? (share.getAttribute('data-print-meta-one') || '__COUNT__ produkt · __DATE__')
      : (share.getAttribute('data-print-meta-other') || '__COUNT__ produkter · __DATE__');
    meta.textContent = tpl.replace(/__COUNT__/g, String(n)).replace(/__DATE__/g, date);
    if (n > 0) {
      page.setAttribute('data-print-url', shareUrl(pageProducts.map(function(p) { return p.handle; })));
    } else {
      page.removeAttribute('data-print-url');
    }
  }

  function resetCopyButton(share) {
    var btn = share.querySelector('[data-favorites-copy]');
    var note = share.querySelector('[data-favorites-copy-note]');
    if (btn) {
      btn.textContent = share.getAttribute('data-copy-label') || 'Kopiera länk';
      btn.classList.remove('is-done');
    }
    if (note) {
      note.hidden = true;
      note.textContent = '';
    }
  }

  function onCopyClick(page) {
    var share = page.querySelector('[data-favorites-share]');
    if (!share || !pageProducts.length) return;
    var handles = pageProducts.map(function(p) { return p.handle; });
    var url = shareUrl(handles);
    copyText(url).then(function() {
      var btn = share.querySelector('[data-favorites-copy]');
      var note = share.querySelector('[data-favorites-copy-note]');
      if (btn) {
        btn.textContent = share.getAttribute('data-copied-label') || 'Länken kopierad';
        btn.classList.add('is-done');
      }
      if (note) {
        note.textContent = share.getAttribute('data-copy-note') || '';
        note.hidden = false;
      }
      if (copyResetTimer) clearTimeout(copyResetTimer);
      copyResetTimer = setTimeout(function() { resetCopyButton(share); }, 4000);
    }).catch(function() {});
  }

  function onPrintClick(page) {
    fillPrintMeta(page, pageProducts.length);
    window.print();
  }

  function onEmailClick(page) {
    var form = page.querySelector('[data-favorites-mail]');
    if (!form || !pageProducts.length) return;
    var opening = form.hidden;
    form.hidden = !opening;
    if (opening) {
      var input = form.querySelector('[data-favorites-mail-email]');
      if (input) input.focus();
    }
  }

  function absHttpUrl(value) {
    var src = String(value || '').trim();
    if (!src) return '';
    if (src.indexOf('//') === 0) return 'https:' + src;
    if (src.indexOf('/') === 0) return window.location.origin + src;
    return src;
  }

  function productImage(product) {
    var src = '';
    if (product.featured_image) src = String(product.featured_image);
    else {
      var images = product.images || [];
      if (!images.length) return '';
      var img = images[0];
      src = typeof img === 'string' ? img : String(img && img.src || '');
    }
    return absHttpUrl(src);
  }

  function emailImageUrl(product) {
    var src = productImage(product);
    if (!src) return '';
    if (/[?&]width=/.test(src)) return src;
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=360';
  }

  function parseJsonSafe(text) {
    if (!text) return {};
    try { return JSON.parse(text); } catch (e) { return {}; }
  }

  function postFavoritesMail(api, payload) {
    return fetch(api, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(res) {
      return res.text().then(function(text) {
        var data = parseJsonSafe(text);
        if (!res.ok) {
          var err = (data && typeof data === 'object') ? data : {};
          err.status = res.status;
          throw err;
        }
        return data;
      });
    });
  }

  function withMailRetry(send) {
    return send().catch(function(err) {
      var status = err && err.status;
      if (status && status < 500) throw err;
      return new Promise(function(resolve) { setTimeout(resolve, 1400); }).then(send);
    });
  }

  function onMailSubmit(page, e) {
    e.preventDefault();
    var share = page.querySelector('[data-favorites-share]');
    var form = page.querySelector('[data-favorites-mail]');
    var input = page.querySelector('[data-favorites-mail-email]');
    var errEl = page.querySelector('[data-favorites-mail-error]');
    var submitBtn = page.querySelector('[data-favorites-mail-submit]');
    var api = (page.getAttribute('data-favorites-mail-api') || '').trim();
    if (!share || !form || !pageProducts.length) return;

    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }

    var email = input ? input.value.trim() : '';
    if (!email || email.indexOf('@') === -1) {
      if (errEl) {
        errEl.textContent = share.getAttribute('data-email-missing') || 'Ange en e-postadress.';
        errEl.hidden = false;
      }
      return;
    }
    if (!api) {
      if (errEl) {
        errEl.textContent = share.getAttribute('data-email-error') || 'Kunde inte skicka. Försök igen.';
        errEl.hidden = false;
      }
      return;
    }

    var listUrl = shareUrl(pageProducts.map(function(p) { return p.handle; }));
    var products = pageProducts.map(function(p) {
      var path = productUrl(p);
      return {
        title: p.title,
        price: String(formatPrice(p.price) || ''),
        url: absHttpUrl(path),
        image: emailImageUrl(p)
      };
    });

    if (submitBtn) submitBtn.disabled = true;
    var payload = {
      email: email,
      list_url: listUrl,
      lang: page.getAttribute('data-favorites-lang') || 'sv',
      products: products
    };
    var fallback = share.getAttribute('data-email-error') || 'Kunde inte skicka. Försök igen.';
    withMailRetry(function() { return postFavoritesMail(api, payload); })
      .then(function() {
        form.hidden = true;
        var note = share.querySelector('[data-favorites-copy-note]');
        var tpl = share.getAttribute('data-email-sent') || 'Listan är skickad till __EMAIL__.';
        if (note) {
          note.textContent = tpl.replace(/__EMAIL__/g, email);
          note.hidden = false;
        }
      })
      .catch(function(err) {
        if (!errEl) return;
        var msg = (err && typeof err.error === 'string') ? err.error : '';
        if (!msg || /postmark|ErrorCode|api\.postmarkapp/i.test(msg)) msg = fallback;
        errEl.textContent = msg;
        errEl.hidden = false;
      })
      .finally(function() {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function renderFavoritesPage() {
    var page = document.querySelector('[data-favorites-page]');
    if (!page) return;

    var grid = page.querySelector('[data-favorites-grid]');
    var empty = page.querySelector('[data-favorites-empty]');
    var loading = page.querySelector('[data-favorites-loading]');
    var countEl = page.querySelector('[data-favorites-page-count]');
    var handles = read();

    if (countEl) formatFavoritesCount(countEl, handles.length);

    if (!grid) return;

    grid.innerHTML = '';
    pageProducts = [];

    if (!handles.length) {
      if (empty) empty.hidden = false;
      if (loading) loading.hidden = true;
      grid.hidden = true;
      setShareVisible(page, 0);
      return;
    }

    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;
    grid.hidden = true;
    setShareVisible(page, 0);

    Promise.all(handles.map(function(handle) {
      return fetchProduct(handle).catch(function() { return null; });
    })).then(function(products) {
      var visible = products.filter(Boolean).filter(shouldShowInGrid);
      pageProducts = visible;
      grid.innerHTML = '';
      visible.forEach(function(product) {
        grid.appendChild(buildCard(product));
      });
      if (loading) loading.hidden = true;
      grid.hidden = visible.length === 0;
      if (empty) empty.hidden = visible.length > 0;
      if (countEl) formatFavoritesCount(countEl, visible.length);
      setShareVisible(page, visible.length);
      fillPrintMeta(page, visible.length);
      syncButtons();
      initCardSliders(grid);
    });
  }

  function onToggleClick(btn) {
    var handles = parseHandles(btn.getAttribute('data-product-handle'));
    var handle = handles[0];
    toggleMany(handles);

    var page = document.querySelector('[data-favorites-page]');
    if (!page) return;

    var card = btn.closest('[data-favorite-card]');
    if (card && !isFavorite(handle)) {
      card.remove();
      pageProducts = pageProducts.filter(function(p) { return p.handle !== handle; });
      var grid = page.querySelector('[data-favorites-grid]');
      var empty = page.querySelector('[data-favorites-empty]');
      var countEl = page.querySelector('[data-favorites-page-count]');
      var remaining = grid ? grid.children.length : 0;
      if (countEl) formatFavoritesCount(countEl, remaining);
      setShareVisible(page, remaining);
      fillPrintMeta(page, remaining);
      if (remaining === 0) {
        if (grid) grid.hidden = true;
        if (empty) empty.hidden = false;
      }
    }
  }

  document.addEventListener('click', function(e) {
    if (e.target.closest('[data-favorites-nav]')) return;

    var page = document.querySelector('[data-favorites-page]');
    if (page) {
      if (e.target.closest('[data-favorites-copy]')) {
        e.preventDefault();
        onCopyClick(page);
        return;
      }
      if (e.target.closest('[data-favorites-print]')) {
        e.preventDefault();
        onPrintClick(page);
        return;
      }
      if (e.target.closest('[data-favorites-email]')) {
        e.preventDefault();
        onEmailClick(page);
        return;
      }
    }

    var btn = e.target.closest('[data-favorite-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    onToggleClick(btn);
  });

  document.addEventListener('submit', function(e) {
    var form = e.target.closest('[data-favorites-mail]');
    if (!form) return;
    var page = form.closest('[data-favorites-page]');
    if (!page) return;
    onMailSubmit(page, e);
  });

  document.addEventListener('tambur:favorites-sync', syncButtons);

  applySharedList();
  updateBadges(read().length);
  syncButtons();
  renderFavoritesPage();

  document.addEventListener('shopify:section:load', function() {
    applySharedList();
    updateBadges(read().length);
    syncButtons();
    renderFavoritesPage();
  });
})();
